exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._36GeG3tJDOlZNWbQs1WUJL .content,._36GeG3tJDOlZNWbQs1WUJL .description a{color:dycolor-internal(!fill-success,@secondary)}._36GeG3tJDOlZNWbQs1WUJL .edit{color:dycolor-internal(!edit,@primary)}._36GeG3tJDOlZNWbQs1WUJL .status.icon-check{color:dycolor-internal(!fill-success,@secondary)}._36GeG3tJDOlZNWbQs1WUJL .status.icon-close{color:dycolor-internal(!fill-error,@theme-error)}\n", ""]);

// exports
exports.locals = {
	"root": "_36GeG3tJDOlZNWbQs1WUJL"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/fill-status/FillStatus.scss
// module id = 902
// module chunks = 1